import React from "react"
import {IconButton, withStyles} from "@material-ui/core"
import ShareIcon from '@material-ui/icons/Share'
import Grid from "@material-ui/core/Grid"
import TableHead from "@material-ui/core/TableHead"
import Table from "@material-ui/core/Table"
import TableRow from "@material-ui/core/TableRow"
import TableCell from "@material-ui/core/TableCell"
import TableBody from "@material-ui/core/TableBody"
import Tooltip from "@material-ui/core/Tooltip";
import KeyboardArrowLeftIcon from "@material-ui/core/es/internal/svg-icons/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@material-ui/core/es/internal/svg-icons/KeyboardArrowRight";
import {
  FORMAT_YMD,
  URL_REVIEW_ATTENDANCES,
  WEEKDAYS
} from "redux/constants"
import styles, {makePeriodClassName} from './styles'
import moment from 'moment-timezone'
import { MuiPickersUtilsProvider, DatePicker } from 'material-ui-pickers'
import MomentUtils from "@date-io/moment";
import { displayFieldsRows, getPeriodDisplayFields, getPeriodToolTipFields } from './periodDisplay'
import { withRouter } from 'react-router-dom'
import { pageLink } from 'apps/admin/components/Link'
import { WeekViewCurrentTimeline } from 'apps/admin/components/WeekViewCurrentTimeline'

class WeekViewClass extends React.Component {

  nextWeek = () =>{
    const {weekCalendar, fetchReviewPeriods} = this.props
    fetchReviewPeriods({dateInWeek:moment(weekCalendar.currentYMD).add(7, 'days'), shouldReset: false})
  }

  previousWeek = () => {
    const {weekCalendar, fetchReviewPeriods} = this.props
    fetchReviewPeriods({dateInWeek:moment(weekCalendar.currentYMD).subtract(7, 'days'), shouldReset: false})
  }

  shareWeekLink = () => {
    // const {location: {pathname}, weekCalendar:{ymdStart}} = this.props
    // const mo = moment(ymdStart)
    // const newPath = `${pathname.split('/week')[0]}/week/${mo.format(FORMAT_YMD)}`
    // const newUrl = `${window.location.protocol}//${window.location.host}${newPath}`
    // this.props.history.push(newPath)
    // if(navigator.clipboard) {
    //   navigator.clipboard.writeText(newUrl)
    //   this.props.snackMessageInfo("Link copied to clipboard");
    // } else {
    //   this.props.snackMessageInfo("Copy the link above to share with authorized people.");
    // }
  }

  render() {
    if(!this.props.weekCalendar || !this.props.show) return null

    const {
      classes,
      weekCalendar,
      currentTimeline
    } = this.props
    
    const earliestHour = 6 < weekCalendar.minHour? 6 : weekCalendar.minHour
    const latestHour = 18 > weekCalendar.maxHour? 18 : weekCalendar.maxHour
    const ymdList = []
    const iMoment = moment(weekCalendar.currentYMD)

    iMoment.subtract(iMoment.day(), 'day')
    const pickerDate = iMoment.format('MMM Do')
    for(let i = 0; i < 7; i++) {
      ymdList.push(iMoment.format(FORMAT_YMD))
      iMoment.add(1, 'day')
    }
    iMoment.subtract(7, 'day') //for the date-picker display

    const mnt = moment()
    mnt.set('hour', earliestHour).set('minute',0).set('second',0)
    const hours = []
    for(let i = earliestHour; i <= latestHour; i++) {
      hours.push(i)
    }

    return <Grid item xs={12}>
      <Table style={{width:'100%'}}>
        <TableHead>
          <TableRow>
            <TableCell style={{width:'12.5%', cursor:'pointer'}} padding={"none"}>
              <Grid container>
                {/* <Grid item xs={5} xl={3}><IconButton onClick={this.shareWeekLink}><ShareIcon/></IconButton></Grid> */}
                <Grid item xs={7} xl={5}>
                  <MuiPickersUtilsProvider utils={MomentUtils} >
                    <DatePicker
                      style={{
                        cursor:'pointer'
                      }}
                      variant='outlined'
                      margin="none"
                      label=""
                      labelFunc={()=>`${pickerDate}`}
                      value={iMoment}
                      onChange={(dateInWeek) => {
                        this.props.fetchReviewPeriods({
                          dateInWeek,
                          shouldReset: false
                        })
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={6} xl={2}><IconButton onClick={this.previousWeek}><KeyboardArrowLeftIcon/></IconButton></Grid>
                <Grid item xs={6} xl={2}><IconButton onClick={this.nextWeek}><KeyboardArrowRightIcon /></IconButton></Grid>
              </Grid>
              </TableCell>
            {ymdList.map((ymd, i) => {
              return <TableCell style={{width:'12.5%'}} key={ymd} title={ymd} >{WEEKDAYS[i]} {ymd.split('-')[2]}</TableCell>
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {hours.map(hour => {
            const fieldsEquivalent = displayFieldsRows < 3
              ? 1
              : (1 + (displayFieldsRows - 3) * 0.32);
            
            mnt.set('hour', hour)
            return <TableRow key={hour} style={{height: 60 * fieldsEquivalent}}> 
              <TableCell style={{verticalAlign: 'text-top'}}>{mnt.format('h:mma')}</TableCell>
              {ymdList.map((ymd, i) => {
                let schedulePeriods = []
                let schedulePeriodsById = {}
                if(weekCalendar.byHour[hour] && weekCalendar.byHour[hour].dates[ymd]) {
                  schedulePeriods = weekCalendar.byHour[hour].dates[ymd].schedulePeriods
                }
                return <TableCell
                  key={ymd}
                  style={{borderLeft:'1px solid #F1F1F1', position:'relative'}}  >
                  {schedulePeriods.map(schedulePeriod => {
                    schedulePeriodsById[schedulePeriod.id] = schedulePeriod

                    let periodCellClassName = '';
                    periodCellClassName = classes[makePeriodClassName(schedulePeriod)]
                    return (
                      <Tooltip
                        key={schedulePeriod.id}
                        title={
                          <>
                            {getPeriodToolTipFields(schedulePeriod).map(({ field, label, value }) => (
                              <div key={field} style={{ margin: 0 }}>
                                {label && <strong>{label}:</strong>} {value}
                              </div>
                            ))}
                          </>
                        }
                      >
                        <div>
                          <div
                            className={classes.periodRoot}
                            style={{
                              top: schedulePeriod.minuteOffset * fieldsEquivalent,
                              left: schedulePeriod.leftPercent + '%',
                              height: schedulePeriod.minuteLength * fieldsEquivalent,
                              width: schedulePeriod.widthPercent + '%',
                              color: schedulePeriod.isEmptyPeriod ? '#595959' : ''
                            }}
                            onClick={() => {
                              this.props.history.push(pageLink(URL_REVIEW_ATTENDANCES, false, schedulePeriod.id))
                            }}
                          >
                            <div className={periodCellClassName}/>
                            <span style={{width: '95%'}} className={classes.periodName}>
                              {getPeriodDisplayFields(schedulePeriod, this.props.isTeacherSelected, this.props.isLocationSelected, this.props.isCourseSelected).map(({ field, label, value }) => (
                                <div
                                  key={field}
                                  style={{
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden'
                                  }}
                                >
                                  {label && <strong>{label}:</strong>} {value}
                                </div>
                              ))}
                            </span>
                          </div>
                        </div>
                      </Tooltip>
                    )
                  })
                  }
                  <WeekViewCurrentTimeline
                    ymd={ymd}
                    hour={hour}
                    fieldsEquivalent={fieldsEquivalent}
                    schedulePeriods={schedulePeriods}
                    earliestHour={earliestHour}
                    latestHour={latestHour}
                    currentTimeline={currentTimeline}
                  />
                </TableCell>
              })}
            </TableRow>
          })}
        </TableBody>
      </Table>
    </Grid>
  }
}

export const WeekView = withRouter(withStyles(styles, { withTheme: true })(WeekViewClass))

export default WeekView